<template>
  <div class="personal-center">
    <div class="personal-center-title"><span></span>基本信息</div>
    <div class="personal-center-from">
      <div class="personal-center-from-left">
        <el-form
          :model="ruleForm"
          status-icon
          ref="ruleForm"
          :rules="rules"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item prop="authorName">
            <p>
              <span class="title"><span class="icon">*</span> 作者姓名</span>
              <span class="value">
                <el-input
                  maxlength="40"
                  placeholder="请输入作者名称"
                  show-word-limit
                  v-model="ruleForm.authorName"
                  style="width: 240px"
                  size="mini"
                  @blur="getNameValue"
                ></el-input>
              </span>
            </p>
          </el-form-item>
          <el-form-item prop="authorRole">
            <p>
              <span class="title"><span class="icon">*</span> 作者角色</span>
              <span class="value">
                <el-select
                  v-model="ruleForm.authorRole"
                  placeholder="请选择"
                  size="mini"
                  style="width: 240px"
                  @change="getAuthorRole"
                >
                  <div v-for="item in roleList" :key="item.value">
                    <el-option
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </div>
                </el-select>
              </span>
            </p>
          </el-form-item>
          <el-form-item prop="accountProfile">
            <p>
              <span class="title"><span class="icon">*</span> 账号简介</span>
              <span class="value">
                <el-input
                  type="text"
                  placeholder="请输入账号简介"
                  v-model="ruleForm.accountProfile"
                  maxlength="30"
                  show-word-limit
                  style="width: 520px"
                  size="mini"
                  @blur="getProfile"
                >
                </el-input>
              </span>
            </p>
          </el-form-item>
          <el-form-item>
            <p>
              <span class="title"> 稿件样例</span>
              <span class="value">
                <el-input
                  v-model="ruleForm.contribution"
                  placeholder="https://"
                  style="width: 520px"
                  size="mini"
                  class="textInput"
                  maxlength="500"
                >
                </el-input>
              </span>
            </p>
            <div class="contribution-font">提供一篇作品样例，增加通过机会</div>
          </el-form-item>
          <el-form-item>
            <p>
              <span class="title">关联业务</span>
              <el-select
                v-model="businessTag"
                multiple
                placeholder="请选择"
                size="mini"
                style="width: 500px"
                class="selectBus"
              >
                <el-option
                  v-for="item in businessOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </p>
          </el-form-item>
          <!-- 关联业务-----------------------------需要新接口 -->
          <div
            class="business-error"
            style="color: #cc0000; margin-left: 60px; display: block"
            v-show="businessError"
          >
            <i class="el-icon-warning"></i>机构ID不存在，请重新输入
          </div>
          <!--          <span v-show="businessList.length == 0" class="value"><el-input @change="getContentBusinessByName" v-model="ruleForm.business" placeholder="请输入关联业务" style="width:520px" size="mini"></el-input></span>-->
        </el-form>
      </div>
      <div class="personal-center-from-right">
        <div class="personal-center-from-right-top">
          <div class="font"><span class="icon">*</span> 头像</div>
          <div class="img">
            <div class="demo-basic--circle">
              <div class="block">
                <el-avatar
                  :size="70"
                  :src="imgUrl ? imgHost + imgUrl : defaultImage"
                  :key="imgHost + imgUrl"
                ></el-avatar>
              </div>
            </div>
            <div class="upload">
              <el-upload
                ref="fileUpload"
                class="upload-demo"
                action="/imageUpload.action"
                :auto-upload="false"
                :http-request="httpRequest"
                :on-change="onImgChange"
                :before-upload="checkFile"
                accept="image/png, image/jpeg,image/gif,image/jpg,image/bmp,image/heic"
                :limit="1"
                :file-list="fileList"
              >
                <el-button size="small" type="primary">上传头像</el-button>
              </el-upload>
            </div>
          </div>
        </div>
        <div class="personal-center-from-right-bottom">
          <i class="el-icon-warning"></i>
          建议尺寸不低于180*180像素，大小不超过1M
        </div>
      </div>
    </div>
    <div class="personal-center-footer">
      <div class="personal-center-footer-xy">
        <span style="color: red">* </span>
        <el-checkbox class="myCheck" v-model="isChecked"></el-checkbox>
        <p>
          请阅读并同意<a
            href="https://cont.jd.com/pccontent/12082538"
            target="_blank"
            style="color: #409eff"
            >《JDH健康内容开放平台服务协议》</a
          >
        </p>
      </div>
      <div class="personal-center-footer-button">
        <el-button type="primary" @click="updateContentUserInfo"
          >提交</el-button
        >
      </div>
      <div class="personal-center-footer-info">
        <span>*个人信息修改后，需重新审核，会在48小时内反馈</span>
      </div>
    </div>
    <!-- vueCropper 剪裁图片实现-->
    <el-dialog
      class="cropper-dialog"
      title="图片剪裁"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogCropperVisible"
      :before-close="closeDialog"
    >
      <div class="cropper-content">
        <div class="cropper" style="text-align: center">
          <vueCropper
            ref="cropper"
            :img="cropperImg"
            :outputSize="0.8"
            outputType="jpeg"
            :info="true"
            :full="true"
            :canScale="true"
            :canMoveBox="true"
            :original="false"
            :autoCrop="true"
            :fixedNumber="[22, 15]"
            :centerBox="true"
            :infoTrue="false"
            :fixedBox="false"
            :autoCropWidth="220"
            :autoCropHeight="150"
            mode="cover"
          ></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="finish">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { uploadFile } from "@/utils/axios";
import { mapState, mapMutations } from "vuex";
import {
  saveOrUpdateContentUser,
  getContentBusinessByName,
  getContentUserInfo,
  listContentBusiness,
  authorizeUser,
} from "@/api/user";
import { login } from "../../../../utils/tools";
import defaultImage from "@/assets/default-header.png";
export default {
  name: "update",
  data() {
    return {
      imgUrl: "",
      fileList: [],
      cropperImg: "",
      dialogCropperVisible: false,
      roleList: [
        {
          label: "其他",
          value: 0,
        },
        {
          label: "写手",
          value: 1,
        },
        {
          label: "医护",
          value: 2,
        },
        {
          label: "运营",
          value: 3,
        },
      ],
      ruleForm: {
        authorName: "",
        authorRole: "",
        accountProfile: "",
        contribution: "",
        business: [],
      },
      businessList: [],
      business: [],
      inputVisible: false,
      inputValue: "",
      businessError: false,
      defaultImage: defaultImage,
      showName: false,
      showDesc: false,
      shouImg: false,
      showRole: false,
      rules: {
        authorName: [
          { required: true, message: "请输入作者姓名", trigger: "blur" },
        ],
        authorRole: [
          { required: true, message: "请选择作者角色", trigger: "change" },
        ],
        accountProfile: [
          { required: true, message: "请输入账号简介", trigger: "blur" },
        ],
      },
      businessOptions: [],
      businessTag: [],
      isChecked: false,
    };
  },
  computed: {
    ...mapState(["imgHost", "userInfo"]),
  },
  created() {
    this.getValue();
    this.listContentBusiness();
    // this.getContentUserInfo()
  },
  watch: {
    userInfo(val) {
      this.getValue();
    },
  },
  methods: {
    ...mapMutations(["setUserInfo"]),
    handleRemove() {},
    beforeRemove() {},
    handleExceed() {},
    handlePreview() {},
    getValue() {
      if (!this.userInfo.headPic) {
        this.imgUrl = "";
      } else {
        this.imgUrl = this.userInfo.headPic;
      }
      this.ruleForm.authorName = this.userInfo.nickName;
      this.ruleForm.authorRole = this.userInfo.identity;
      this.ruleForm.accountProfile = this.userInfo.briefing;
      this.ruleForm.contribution = this.userInfo.exampleUrl;
      this.userInfo.contentBusinessDTOs &&
        this.userInfo.contentBusinessDTOs.forEach((item) => {
          this.businessTag.push(item.id);
        });
      // this.ruleForm.business.forEach(item => {
      //   this.businessList.push(item.id)
      // })
    },
    closeDialog() {
      this.dialogCropperVisible = false;
      this.fileList = [];
    },
    // 添加或修改用户信息
    updateContentUserInfo() {
      if (!this.isChecked) {
        this.$message.error("请阅读并同意《JDH健康内容开放平台服务协议》");
        return;
      }
      this.businessOptions &&
        this.businessOptions.forEach((item) => {
          this.business.push(item.value);
        });
      if (!this.imgUrl) {
        this.$message.error("请上传头像");
      }
      //
      if (this.imgUrl) {
        let params = {
          tenantId: this.$commonJs.getTenantId(),
          nickName: this.ruleForm.authorName,
          headPic: this.imgUrl,
          identity: this.ruleForm.authorRole,
          briefing: this.ruleForm.accountProfile,
          exampleUrl: this.ruleForm.contribution,
          contentBusinessIds: this.businessTag,
          auditStatus: 1,
          agreeContentServiceProtocol: this.isChecked,
        };
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            saveOrUpdateContentUser(params)
              .then((res) => {
                this.userInfo.auditStatus = 1;
                this.setUserInfo(this.userInfo);
                // 此处可以优化，写个递归查询children属性。
                // 重新审核之后，左侧菜单需要更新
                // window.$vm.$children[0].$children[0].$children[1].init();
                if (res) {
                  this.$router.push(`/personalCenter/detail`);
                }
              })
              .catch((error) => {
                if (error && error.code == "2408") {
                  this.$message.success("保存成功！");
                }
                console.log(error);
              });
          } else {
            return false;
          }
        });
      }
    },
    // 获取用户关联的所有业务
    listContentBusiness() {
      listContentBusiness({
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        // this.businessOptions = res
        res.forEach((item) => {
          this.businessOptions.push({
            label: item.name,
            value: item.id,
          });
        });
      });
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        // this.getOriginalAuthorsByName(query)
      } else {
        this.businessOptions = [];
      }
    },
    getContentBusinessByName() {
      if (this.inputValue) {
        getContentBusinessByName({
          tenantId: this.$commonJs.getTenantId(),
          name: this.inputValue,
        })
          .then((res) => {
            this.ruleForm.business.push({
              name: res.name,
              id: res.id,
            });
            //  this.ruleForm.business.forEach((item,index) => {
            //    if(item.name != this.inputValue) {
            //       this.ruleForm.business.push(item)
            //    }
            //  })
            this.inputValue = "";
          })
          .catch((error) => {
            this.inputValue = "";
            this.businessError = true;
          });
      }
    },
    closeTag(tag) {
      this.ruleForm.business.splice(this.businessList.indexOf(tag.id), 1);
    },
    handleClose(tag) {},
    businessErrorHandle() {
      this.businessError = false;
    },
    showInput() {
      this.inputVisible = true;
      this.businessError = false;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    onImgChange(file, fileList) {
      if (!file.url) {
        var baseData;
        var reader = new FileReader();
        reader.readAsDataURL(file.raw);
        reader.onload = () => {
          baseData = reader.result;
          this.cropperImg = baseData;
          this.dialogCropperVisible = true;
        };
        return;
      }

      this.cropperImg = file.url;
      this.dialogCropperVisible = true;
    },
    checkFile(file) {
      const isJPG = /image\/(jpeg|png)/.test(file.type);
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("上传图片只能是jpg、png格式！");
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      let data = window.URL.createObjectURL(new Blob([file]));

      return isJPG && isLt5M;
    },
    httpRequest(request) {
      let file = this.file;
      this.uploadFile(file, (msg) => {
        this.imgUrl = msg;
      });
    },
    uploadFile(file, callback) {
      uploadFile(file, (event) => {
        let percent = parseInt((event.loaded / event.total) * 100 + "");
        if (percent > 99) {
          percent = 99;
        }
        file.progress = percent;
        file.status = "pending";
        // this.setStoragePropertyByName(storageProperty, uploadImageList);
      })
        .then((res) => {
          const id = res.data[0]["id"];
          if (id === "1") {
            const url = res.data[0]["msg"];
            callback && callback(url);
            file.status = "resolve"; // 是否上传成功，根据是否有url来判断
          } else if (id === "0") {
            this.$message.error("图片上传失败");
          }
          this.fileList = [];
        })
        .catch((error) => {
          file.status = "reject";
          this.fileList = [];
          this.$message.error("图片上传失败");
        });
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      this.dialogCropperVisible = false;
      this.$refs.cropper.getCropBlob((data) => {
        this.file = data;
        this.$refs.fileUpload.submit();
      });
    },
    cancel() {
      this.dialogCropperVisible = false;
      // this.imgUrl='';
      this.fileList = [];
    },
  },
};
</script>
<style scoped lang="scss">
.personal-center {
  :deep(.el-input__inner) {
    height: 32px;
    line-height: 32px;
  }

  .cropper-dialog {
    .el-dialog {
      width: 450px;
    }
    .cropper-content {
      width: 100%;
      padding: 20px;
      .cropper {
        width: 100%;
        height: 288px;
      }
    }
  }
  &-title {
    span {
      display: inline-block;
      height: 10px;
      border: 1.5px solid #1d61ff;
      margin-right: 5px;
    }

    color: #2e3646;
    font-size: 14px;
    font-weight: bold;
  }

  &-from {
    padding: 10px;
    display: flex;

    &-left {
      flex-grow: 3;

      .contribution-font {
        margin-left: 100px;
        margin-top: -14px;
        color: #9ca8b9;
        font-size: 14px;
      }

      p {
        display: flex;
        align-items: center;

        &:first-child {
          position: relative;
          margin-left: -8px;

          .icon {
            color: #f62458;
          }
        }

        &:nth-child(2) {
          margin-left: -8px;
          position: relative;

          .icon {
            color: #f62458;
          }
        }

        &:nth-child(3) {
          margin-left: -8px;
          position: relative;

          .icon {
            color: #f62458;
          }
        }

        &:last-child {
          margin-top: 0;
        }

        margin-top: 32px;

        .title {
          color: #8b8c9a;
        }

        .value {
          margin-left: 15px;
        }

        .el-tag + .el-tag {
          margin-left: 10px;
        }

        .button-new-tag {
          /*margin-left: 10px;*/
          height: 26px;
          line-height: 30px;
          padding-top: 0;
          padding-bottom: 0;
          border: none;
          line-height: 26px;
          color: rgb(220, 223, 230);
        }

        .input-new-tag {
          width: 200px;
          margin-left: 0px;
          vertical-align: bottom;
          border: none;
          padding-left: 0;

          :deep(.el-input__inner) {
            border: none !important;
            line-height: 26px;
            height: 26px;
          }
        }

        .business-list {
          display: inline-block;
          width: 520px;
          height: 32px;
          border: 1px solid #dcdfe6;
          border-radius: 4px;
          margin-left: 15px;
        }

        .business-tag {
          line-height: 32px;
          /*margin-left: 10px;*/
          display: inline-block;

          :deep(.el-button:hover) {
            background-color: #ffffff;
          }
        }
      }
    }

    &-right {
      flex-grow: 1;
      color: #2c3443;

      &-top {
        display: flex;

        .font {
          flex-grow: 0.5;
          padding: 10px;
          margin-left: -8px;

          .icon {
            color: #f62458;
          }
        }

        .img {
          flex-grow: 2;

          .block {
            width: 84px;
            border: 1px dashed #8b8c9a;
            height: 84px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
          }

          .upload {
            :deep(.el-button--primary) {
              background-color: #1d61ff;
            }

            margin-top: 10px;
          }
        }
      }

      &-bottom {
        margin-top: 22px;
        color: #ff9b39;
      }
    }
  }

  &-footer {
    padding: 10px;
    margin-top: 40px;

    &-button {
      .disable {
        background-color: #606064e7;
        cursor: not-allowed;
      }
    }

    &-info {
      margin-top: 10px;
      color: #9ca8b9;
    }
  }
}

.showName,
.showDesc {
  color: red;
  position: absolute;
  top: 35px;
  left: 101px;
}

.selectBus {
  margin-left: 15px;
}

:deep(.el-form-item) {
  &:nth-child(1),
  &:nth-child(2),
  &:nth-child(3) {
    margin-left: -63px;
    margin-bottom: 13px;
  }

  &:nth-child(4) {
    margin-left: -53px;
    margin-top: -29px;
  }

  &:nth-child(5) {
    margin-left: -53px;
  }
}

.textInput {
  margin-left: -10px;
}

.selectBus {
  margin-left: 5px;
}

.personal-center-footer-xy {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .myCheck {
    margin: 0 5px;
  }
}
</style>
